module.exports = __webpack_public_path__ + "static/media/house4.3341c88a.webp";